import { apiHooks } from 'react-api-query';

import * as api from '../utils/api';

export const { useApiQuery, useApiMutation } = apiHooks(api);
